// Customer testimonials for the Absolute Hammer landing page.
// TODO: replace these placeholder quotes with real customer feedback.

export const HAMMER_REVIEWS = [
  {
    quote:
      '"I am writing this review as a licensed marine contractor in the state of Florida. I purchased one of their air hammers and it has been the best one my company has owned to date. The remote box that comes with the hammer is a wonderful design and upgrade vs anything I have used to date. Everything I had seen done wrong by other manufacturers they corrected. I will definitely buy from them again."',
    name: 'Charles Hodges',
    attribution: 'Licensed FL Marine Contractor · Google review',
    rating: 5,
  },
  {
    quote:
      '"Purchased a pile hammer from Absolute Marine Equipment and have been really impressed with it so far! It\u2019s a solid piece of equipment and has done exactly what we needed it to do. It feels well built, works efficiently, and has handled the demands of jobs. We\u2019ve dealt with a few equipment companies over the years, and the quality of this one definitely stands out. Very happy with our purchase and would have no problem buying from Absolute Marine Equipment again!"',
    name: 'Sara H.',
    attribution: 'Verified Google review · Absolute Hammer owner',
    rating: 5,
  },
  {
    quote:
      '“Solid, simple, galvanized. No hydraulic mess, just air in and pilings down. Best purchase we made last year.”',
    name: 'Jack H.',
    attribution: 'Gulfshore Marine',
    rating: 5,
  },
];
